import React, { useState, useEffect, useRef } from 'react'
import { Panel, Message, Row, Col, ControlLabel, DatePicker, Uploader, Icon, Table } from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isImageOrPdf, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import { DATE_FORMAT, DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import InputForm from '../../components/forms/input/InputForm'
import moment from 'moment'
import UpdateListAttachFilesTable from './UpdateListAttachFilesTable'
import AccountingPeriodWidget from '../panelHeder/AccountingPeriodWidget'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { sessionGetItemJSON, sessionGetItemStr } from '../../utils/sessionHelpers'
import notification from '../../utils/notification'

export default function UpdateListForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  periodInfo,
  onPreview = () => {},
  onDownload = () => {},
  projectStartDate,
  projectEndDate,
  ...props
}) {
  const triggerRef = React.useRef()

  const [formSchema, setFormSchema] = useState(_schema)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileTableData, setFileTableData] = useState([])

  const defaultMaxFileSize = 5

  useEffect(() => {
    // console.log('UpdateListForm reload')
    setFormSchema(_schema)
    setValue(_schema.attachFiles.name, [])

    register('deleteFileIds', [])

    if (_schema?.attachFiles?.values && _schema?.attachFiles?.values?.length > 0) {
      setFileTableData(_schema?.attachFiles?.values)
    }
  }, [_schema])

  const handleDeleteFile = (rowData) => {
    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)

    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={<AccountingPeriodWidget periodInfo={periodInfo} />}
      >
        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.documentNumber.validators, formSchema.documentNumber.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.documentNumber.value ? (
              <b>{formSchema.documentNumber.value}</b>
            ) : (
              <>
                <InputForm
                  schema={formSchema.documentNumber}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  hideLabel
                  style={{ marginTop: -5 }}
                />
              </>
            )}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.documentDate.validators, formSchema.documentDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <Controller
              key={formSchema.documentDate.name}
              name={formSchema.documentDate.name}
              control={control}
              defaultValue={
                // moment(schema.reportDate.value).format('YYYY-MM-DD')
                formSchema.documentDate.value
                  ? moment(formSchema.documentDate.value, DATE_PICKER_FORMAT).toDate()
                  : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                  ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                  : new Date()
              }
              rules={isValidators(formSchema.documentDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    startDate={periodInfo?.periodDateStart}
                    endDate={periodInfo?.periodDateEnd}
                    // startDate={sessionGetItemStr('projectStartDate')}
                    // endDate={sessionGetItemStr('projectEndDate')}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.description.validators, formSchema.description.label)}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <InputForm
              schema={formSchema.description}
              rows={3}
              componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.attachFiles.validators,
                formSchema.attachFiles.label || 'เอกสารแนบประกอบ'
              )}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {/* <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${
                formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
              }`}
              style={{ marginBottom: 10 }}
            /> */}
            <ErrorMessage error={errors[formSchema.attachFiles.name]} />

            {fileTypeError && (
              <Message
                closable
                onClose={() => {
                  setFileTypeError(false)
                }}
                showIcon
                type="error"
                description="อัพโหลดไฟล์เป็นรูปภาพหรือ PDF เท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg , pdf ***"
              />
            )}
            <Controller
              key={formSchema.attachFiles.name}
              name={formSchema.attachFiles.name}
              control={control}
              rules={isValidators(formSchema.attachFiles.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                    autoUpload={false}
                    disabled={formSchema.attachFiles.disabled}
                    fileListVisible={true}
                    listType="picture-text"
                    fileList={props.value || []}
                    multiple
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024
                        ) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema.attachFiles.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          props.onChange(fileList)
                          setFileTypeError(false)
                        } else {
                          setFileTypeError(true)
                          // notification.open('error', {
                          //   title: 'ชนิดที่รองรับ png, jpeg, jpg, pdf',
                          //   duration: 5000,
                          // })
                        }
                      }
                    }}
                    draggable
                  >
                    <div>
                      <Icon size="2x" icon="upload2" />
                      <small className="uploder__text"></small>
                      {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                        formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                      } , ขนาดไฟล์ไม่เกิน ${
                        formSchema.attachFiles.fileSize || defaultMaxFileSize
                      } MB`}
                    </div>
                    {/* <div style={{ lineHeight: '100px' }}>
                      <Icon size="4x" icon="upload2" />
                      <small
                        style={{
                          marginTop: '-70px',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                      </small>
                    </div> */}
                  </Uploader>
                )
              }}
            />
            <br></br>
            {fileTableData.length > 0 && (
              <UpdateListAttachFilesTable
                //schema={formSchema.attachFiles}
                data={fileTableData}
                onDownload={onDownload}
                onPreview={onPreview}
                onDelete={handleDeleteFile}
                deleteEnable={true}
              />
            )}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
